
export default {
  props: {
    dark: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      icon: 'weather-sunny',
    }
  },
  mounted() {
    const saveDarkMode = localStorage.getItem('darkMode')
    if (saveDarkMode !== null) {
      this.$vuetify.theme.isDark = saveDarkMode === 'true'
      this.updateIcon()
    }
    this.$watch('$vuetify.theme.isDark', (newVal) => {
      localStorage.setItem('darkMode', newVal)
      this.updateIcon()
    })
  },
  methods: {
    darkAction() {
      this.$vuetify.theme.isDark = !this.$vuetify.theme.isDark
    },
    updateIcon() {
      this.icon = this.$vuetify.theme.isDark
        ? 'weather-night'
        : 'white-balance-sunny'
    },
  },
}
